import { buildExportStudentsApiV2ExportStudentsForSchoolSchoolIdGetPath } from '../generated/schooly-api-v2';
import { Api as ApiV2Students } from '../generated/schooly-api-v2/ApiRoute';
import { GetStudentsQueryFilters, GetStudentsQuerySort } from '../school';
import { SORT_DIRECTION } from './misc';

export const getExportStudentsPath = buildExportStudentsApiV2ExportStudentsForSchoolSchoolIdGetPath;

export type ExportStudentsQuery =
  ApiV2Students.ExportStudentsApiV2ExportStudentsForSchoolSchoolIdGet.RequestQuery;

export enum StudentExportIncludeEnum {
  GivenName = 'given_name',
  LastName = 'last_name',
  DateOfBirth = 'date_of_birth',
  Email = 'email',
  AgeGroup = 'age_group',
  Id = 'id',
  Status = 'student_status',
  StatusAppliesFrom = 'status_applies_from',
  MedicalNeedsDescription = 'medical_needs_description',
  MedicalNeedsSevere = 'medical_needs_severe',
  MedicalNeedsReviewStatus = 'medical_needs_review_status',
  PrimaryContactGivenName = 'primary_contact_given_name',
  PrimaryContactLastName = 'primary_contact_last_name',
  PrimaryContactPhoneNumber = 'primary_contact_phone_number',
  PrimaryContactEmail = 'primary_contact_email',
  House = 'house',
  TutorGroup = 'tutor_group',
  Nationality = 'nationality',
  CustomFields = 'custom_fields',
}

export type ExportStudentsResponseBody = File;

export type ExportStudentsSort = {
  columnTextId: GetStudentsQuerySort['columnTextId'];
  direction: SORT_DIRECTION;
};

export type ExportStudentsParams = {
  schoolId: string;
  filters: GetStudentsQueryFilters;
  include: StudentExportIncludeEnum[];
  custom_field_ids: string[];
  sort?: ExportStudentsSort[];
};
